/** Pure number formatting for plans (#572) — no API import, so Home's pure rows can use it. */

/** A signed number in its unit: +0.6 pts, −120 orders. */
export function signed(v: number, unit?: string | null): string {
  const abs = Math.abs(v);
  const digits = abs !== 0 && abs < 1 ? 2 : abs < 100 ? 1 : 0;
  const s = `${v > 0 ? '+' : v < 0 ? '−' : '±'}${abs.toLocaleString(undefined, { maximumFractionDigits: digits })}`;
  return unit ? `${s} ${unit.replace(/_/g, ' ')}` : s;
}

export const plain = (v: number) => v.toLocaleString(undefined, { maximumFractionDigits: Math.abs(v) < 1 ? 2 : 1 });

/** A metric's unit as words: week8_retention → week8 retention. */
export const unitWords = (unit?: string | null) => (unit ? unit.replace(/_/g, ' ') : '');
